import {
	Card, CardContent,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer, TableFooter,
	TableHead,
	TableRow, useMediaQuery, useTheme,
} from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import { NumericFormat } from "react-number-format";
import QuickViewInfoWrap from "../../../../components/mui/app/quickViewInfoWrap/quickViewInfoWrap";
import ContentNotFound from "../../../../components/mui/general/contentNotFound/contentNotFound";
import {
	quickview_view_items_price,
	quickview_view_items_total_value,
	quickview_view_items_value
} from "../../../../helpers/rights/rights";
import { numericFormatDefaults } from "../../../../helpers/theme/defaultProps";
import PermissionHOC from "../../../permission/components/permissionHOC/permissionHOC";

const ItemsTable = ({ items = [], t, thousandSeparator, decimalSeparator }) => {
	const theme = useTheme();
	const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
	return (
		<ContentNotFound displayContent={items.length > 0} message={t('No items found!')}>
			{isSmall ? (
				<Box sx={{ display: 'grid', gap: 2, p: 1 }}>
					{items.map((item, idx) => {
						const value = (parseFloat(item.Qty || 0) * parseFloat(item.Price || 0)).toFixed(2);
						return (
							<Card key={idx} sx={{ p: 1 }}>
								<QuickViewInfoWrap
									label={t('Item')}
								>
									{item.Code ? `${item.Code} | ${item.Description}` : '-'}
								</QuickViewInfoWrap>
								<QuickViewInfoWrap
									label={t('Description')}
								>
									{item.ItemDescription || '-'}
								</QuickViewInfoWrap>
								<QuickViewInfoWrap
									label={t('Quantity')}
								>
									<NumericFormat
										thousandSeparator={thousandSeparator}
										decimalSeparator={decimalSeparator}
										displayType="text"
										value={item.Qty ?? 0}
										decimalScale={2}
									/>
								</QuickViewInfoWrap>
								<PermissionHOC
									requiredPermissions={[quickview_view_items_price]}
								>
									<QuickViewInfoWrap
										label={t('Price')}
									>
										<NumericFormat
											thousandSeparator={thousandSeparator}
											decimalSeparator={decimalSeparator}
											displayType="text"
											value={item.Price ?? 0}
											decimalScale={2}
										/>
									</QuickViewInfoWrap>
								</PermissionHOC>
								<PermissionHOC
									requiredPermissions={[quickview_view_items_value]}
								>
									<QuickViewInfoWrap
										label={t('Value')}
									>
										<NumericFormat
											thousandSeparator={thousandSeparator}
											decimalSeparator={decimalSeparator}
											displayType="text"
											value={value}
											decimalScale={2}
										/>
									</QuickViewInfoWrap>
								</PermissionHOC>
							</Card>
						);
					})}
					<PermissionHOC
						requiredPermissions={[quickview_view_items_total_value]}
					>
						<Card sx={{ p: 1 }}>
							<QuickViewInfoWrap
								label={t('Total Value')}
							>
								<NumericFormat
									thousandSeparator={thousandSeparator}
									decimalSeparator={decimalSeparator}
									displayType="text"
									value={items.reduce((sum, item) => sum + (parseFloat(item.Qty * item.Price) || 0), 0)}
									decimalScale={2}
								/>
							</QuickViewInfoWrap>
						</Card>
					</PermissionHOC>
				</Box>
			) : (
				<TableContainer component={Paper} sx={{ width: '100%', overflowX: 'auto' }}>
					<Table size="small" aria-label="items table">
						<TableHead>
							<TableRow>
								<TableCell sx={{ fontWeight: 'bold' }}>{t('Item')}</TableCell>
								<TableCell sx={{ fontWeight: 'bold' }}>{t('Description')}</TableCell>
								<TableCell sx={{ fontWeight: 'bold' }} align="right">{t('Quantity')}</TableCell>
								<PermissionHOC
									requiredPermissions={[quickview_view_items_price]}
								>
									<TableCell sx={{ fontWeight: 'bold' }} align="right">{t('Price')}</TableCell>
								</PermissionHOC>
								<PermissionHOC
									requiredPermissions={[quickview_view_items_value]}
								>
									<TableCell sx={{ fontWeight: 'bold' }} align="right">{t('Value')}</TableCell>
								</PermissionHOC>
							</TableRow>
						</TableHead>
						<TableBody>
							{items.map((item, index) => (
								<TableRow key={index}>
									<TableCell>
										{item.Code ? `${item.Code} | ${item.Description}` : "-"}
									</TableCell>
									<TableCell>{item.ItemDescription || "-"}</TableCell>
									<TableCell align="right">
										<NumericFormat
											{...numericFormatDefaults}
											thousandSeparator={thousandSeparator}
											decimalSeparator={decimalSeparator}
											displayType="text"
											value={item.Qty ?? "-"}
											decimalScale={2}
										/>
									</TableCell>
									<PermissionHOC
										requiredPermissions={[quickview_view_items_price]}
									>
										<TableCell align="right">
											<NumericFormat
												thousandSeparator={thousandSeparator}
												decimalSeparator={decimalSeparator}
												displayType="text"
												value={item.Price ?? "-"}
												decimalScale={2}
											/>
										</TableCell>
									</PermissionHOC>
									<PermissionHOC
										requiredPermissions={[quickview_view_items_value]}
									>
										<TableCell align="right">
											<NumericFormat
												thousandSeparator={thousandSeparator}
												decimalSeparator={decimalSeparator}
												displayType="text"
												value={item.Qty * item.Price}
												decimalScale={2}
											/>
										</TableCell>
									</PermissionHOC>
								</TableRow>
							))}
						</TableBody>
						<PermissionHOC
							requiredPermissions={[quickview_view_items_total_value]}
						>
							<TableFooter>
								<TableRow>
									<TableCell colSpan={4}>
									</TableCell>
									<TableCell align="right" sx={{ fontWeight: 'bold' }}>
										<NumericFormat
											thousandSeparator={thousandSeparator}
											decimalSeparator={decimalSeparator}
											displayType="text"
											value={items.reduce((sum, item) => sum + (parseFloat(item.Qty * item.Price) || 0), 0)}
											decimalScale={2}
										
										/>
									</TableCell>
									<TableCell/>
								</TableRow>
							</TableFooter>
						</PermissionHOC>
					</Table>
				</TableContainer>
			)}
		</ContentNotFound>
	)
};

export default ItemsTable